import { Box, Grid, Skeleton, Stack } from '@mui/material';
import React from 'react';

const TabLoader = ({ loop }: { loop?: number }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mt={2} marginLeft={1}>
        <Stack gap={1.5}>
          {Array(loop ?? 10)
            .fill(0)
            .map(() => (
              <Stack direction="row">
                <Box width={200}>
                  <Skeleton animation="wave" height={25} width={100} />
                  <Skeleton animation="wave" height={25} width={130} />
                </Box>
                <Box>
                  <Skeleton animation="wave" height={25} width={100} />
                  <Skeleton animation="wave" height={25} width={130} />
                </Box>
              </Stack>
            ))}
        </Stack>
      </Grid>
    </Box>
  );
};

export default TabLoader;
